import { connect } from 'react-redux';

import { BuilderStatus } from '../../components/BuilderStatus';
import { compose } from 'ramda';
import { withEmptyRendering } from '../../utils/hoc/withEmptyRendering';
import { INewbuildingLabel, IOnlineDealSettings, TLabelType } from '../../types/newbuildingLabel';
import { IApplicationState } from '../../types/redux';
import { getNewbuildingId } from '../../selectors/newbuilding';

export interface IBuilderStatusContainerStoreProps {
  labelText: string;
  tooltipTitle: string;
  tooltipText: string;
}

export const getLabelType = (
  newbuildingId: number,
  onlineDealSettings: IOnlineDealSettings[],
  isFromDeveloper: boolean,
  isFromLeadFactory: boolean,
): TLabelType | null => {
  let type: TLabelType | null = null;

  if (isFromDeveloper) {
    type = 'builderOnline';
  }

  if (isFromLeadFactory) {
    type = 'consultantOnline';
  }

  onlineDealSettings.forEach(regionSettings => {
    if (regionSettings.newBuildingIds.includes(newbuildingId) && isFromDeveloper) {
      type = 'onlineDeal';
    }
  });

  return type;
};

export const getTexts = (newbuildingLabel: INewbuildingLabel, type: TLabelType) => {
  return {
    labelText: newbuildingLabel.indicatorTexts[type],
    tooltipTitle: newbuildingLabel.infoTexts[type].title,
    tooltipText: newbuildingLabel.infoTexts[type].text,
  };
};

export function mapStateToProps(state: IApplicationState): IBuilderStatusContainerStoreProps {
  const {
    newbuildingLabel,
    newbuilding: { fromDevelopersPropsCount, sellers },
  } = state;

  let labels = {
    labelText: '',
    tooltipTitle: '',
    tooltipText: '',
  };

  if (!newbuildingLabel) {
    return labels;
  }

  const isEnabled = newbuildingLabel.isEnabled;
  if (!isEnabled) {
    return labels;
  }

  const isFromDeveloper = Boolean(fromDevelopersPropsCount);
  const isFromLeadFactory = Boolean(sellers && sellers[0] && sellers[0].isLeadFactory);
  const newbuildingId = getNewbuildingId(state);

  if (newbuildingId) {
    const type = getLabelType(newbuildingId, newbuildingLabel.onlineDeal, isFromDeveloper, isFromLeadFactory);

    if (type) {
      labels = getTexts(newbuildingLabel, type);
    }
  }

  return labels;
}

export const shouldHideLabel = (props: IBuilderStatusContainerStoreProps) => {
  return !props.labelText;
};

export const BuilderStatusContainer = compose(
  connect(mapStateToProps),
  withEmptyRendering(shouldHideLabel),
)(BuilderStatus);
